module.exports = __webpack_public_path__ + "img/D201411_1.3c6a52af.jpg";